import { ProductGallery } from "../objects/product/product-gallery"
import { SlideDrawer } from "../objects/slide-drawer"

const SEL_BUNDLE_FORM_TOGGLE = '[data-personalisation-form-toggle]';
const SEL_BUNDLE_FORM_DRAWER = '[data-personalisation-engine]';
const SEL_BUNDLE_RADIOS = '[data-bundle-radio]';

export class PersonalisationOptionForm extends HTMLElement {
  private personalisationCreateBtn: HTMLButtonElement | null = null
  private bundleCreateDrawer: SlideDrawer | null = null
  private bundleRadios: HTMLInputElement[] = [];
  private glassAttribute:string = 'is-glass';

  private productGallery: ProductGallery | null = null;

  set galleryInstance(value: ProductGallery | null) {
    this.productGallery = value;
  }

  get galleryInstance(): ProductGallery | null {
    return this.productGallery;
  }

  constructor() {
    super()

    this.queryChildren();
    this.attachEvents();
  }

  queryChildren() {
    this.personalisationCreateBtn = this.querySelector(SEL_BUNDLE_FORM_TOGGLE);
    this.bundleCreateDrawer = document.querySelector(SEL_BUNDLE_FORM_DRAWER);
    this.bundleRadios = [...this.querySelectorAll(SEL_BUNDLE_RADIOS)]

  }

  handleBundleRadioChange(radio: HTMLInputElement) {
    const event = new CustomEvent('variant_change', { 
      detail: { addGlass: radio.hasAttribute(this.glassAttribute) }, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

  setActiveOption(addGlass:boolean) {
    this.bundleRadios.forEach(radio => {
      const isGlassOption = radio.hasAttribute(this.glassAttribute);
      radio.checked = isGlassOption === addGlass;
    });
  }

  attachEvents() {
    if(this.personalisationCreateBtn) {
      this.personalisationCreateBtn.addEventListener("click", () => {
        if (this.bundleCreateDrawer) {
          this.bundleCreateDrawer.visible = true;
        }
      });
    }

    if (this.bundleRadios) {
      this.bundleRadios.forEach(radio => radio.addEventListener('change', () => this.handleBundleRadioChange(radio)))
    }
  }
}

if(!customElements.get('personalisation-option')) {
  customElements.define('personalisation-option', PersonalisationOptionForm);
}